export const KIOSK = 'kiosk';

// Manage Kiosk Views
export const LOCATION = 'LOCATION';
export const READERS = 'READERS';
export const STORE_CODE = 'STORE_CODE';
export const FAQ = 'FAQ';
